import React, { useContext } from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import { useDeviationViewContext } from '../../../../Context';
import { SecondaryActionBarContext } from '../../../ActionBarContext';
import ActionBarStrip from '../../../_partials/ActionBarStrip';
import SubscribersOnly from '../../../_partials/SubscribersOnly';
import { useDeviationAttributes } from '../../../../DeviationViews/hooks/useDeviationAttributes';
import { isTextualDeviation, isHyped } from '../../../../DeviationViews/_helpers';
import DeviationFlags from '../../../buttons/DeviationFlags';
import CommentButton from '../../../buttons/CommentButton';
import FavouriteButton from '../../../buttons/FavouriteButtonWithPopover';
import AddToGroupButton from '../../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../../buttons/MoreButton';
import EditButton from '../../../buttons/EditButton';
import EditBackgroundButton from '../../../buttons/EditBackgroundButton';
import DeleteButton from '../../../buttons/DeleteButton';
import ExpandButton from '../../../buttons/ExpandButton';
import FreeDownloadButton from '../../../buttons/DownloadButton/FreeDownloadButton';
import PremiumDownloadButton from '../../../buttons/DownloadButton/PremiumDownloadButton';
import AwardBadgeButton from '../../../buttons/AwardBadgeButton';
import SellYourArtLink from '../../../buttons/SellYourArtLink';
import FluidMargin from '../FluidMargin';
import AdoptSeller from '../../../buttons/AdoptableSeller';
import AdoptBuyer from '../../../buttons/AdoptableBuyer';
import AddToPrivateCollectionButtonWithPopover from '../../../buttons/AddToPrivateCollectionButtonWithPopover';
import { ElementVisibility, useElementVisibilityForArea } from '../../../ElementVisibilityContext';
import BoostButton from '../../../buttons/BoostButton';
import desktopActionBarStyles from '../DesktopActionBar.scss';
export const PrimaryDesktopActionBar = ({ deviation, isOwner, className })=>{
    const elementVisibilityMap = useElementVisibilityForArea(ElementVisibility.PrimaryBar);
    const { isTheater } = useDeviationViewContext();
    const { setTopActionBarRef } = useContext(SecondaryActionBarContext);
    const { hasFlag } = useDeviationAttributes(deviation, isOwner);
    const isTextual = isTextualDeviation(deviation);
    const hasBothBadges = deviation.dailyDeviation && isHyped(deviation);
    const badgeClassnames = classnames(desktopActionBarStyles['badge'], hasBothBadges && desktopActionBarStyles['both-badges'], elementVisibilityMap.subscribe && desktopActionBarStyles['subs-badge']);
    return /*#__PURE__*/ React.createElement(ActionBarStrip, {
        ref: setTopActionBarRef,
        className: classnames(desktopActionBarStyles['root'], isTheater ? desktopActionBarStyles['theater'] : desktopActionBarStyles['normal-view'], isOwner && desktopActionBarStyles['owner'], isTextual && desktopActionBarStyles['literature'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: badgeClassnames
    }, hasFlag && /*#__PURE__*/ React.createElement(DeviationFlags, {
        className: desktopActionBarStyles['flag'],
        deviation: deviation,
        disableLabel: isTextual
    }), elementVisibilityMap.subscribe && /*#__PURE__*/ React.createElement(SubscribersOnly, {
        deviation: deviation,
        className: desktopActionBarStyles['subscribers-only'],
        textClassName: desktopActionBarStyles['subscribers-only-text']
    })), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 1
    }), /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-middle']
    }, /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, elementVisibilityMap.favourite && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'], desktopActionBarStyles['icon-with-label'])
    }, /*#__PURE__*/ React.createElement(FavouriteButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), elementVisibilityMap.comment && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'], desktopActionBarStyles['icon-with-label'])
    }, /*#__PURE__*/ React.createElement(CommentButton, {
        deviation: deviation,
        isOwner: isOwner,
        actionBarType: "primary"
    }))), !isOwner && /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 4
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, elementVisibilityMap.privateCollection && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(AddToPrivateCollectionButtonWithPopover, {
        deviation: deviation,
        actionBarType: "primary"
    })), elementVisibilityMap.addToGroup && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), elementVisibilityMap.awardBadge && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'])
    }, /*#__PURE__*/ React.createElement(AwardBadgeButton, {
        deviation: deviation
    })), elementVisibilityMap.premiumDownload && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'])
    }, /*#__PURE__*/ React.createElement(PremiumDownloadButton, {
        deviation: deviation
    })), elementVisibilityMap.freeDownload && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'])
    }, /*#__PURE__*/ React.createElement(FreeDownloadButton, {
        deviation: deviation
    })), elementVisibilityMap.elementGroups.adoptableSeller.groupVisibility && /*#__PURE__*/ React.createElement(AdoptSeller, {
        className: desktopActionBarStyles['icon'],
        deviation: deviation
    }), elementVisibilityMap.elementGroups.adoptableBuyer.groupVisibility && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(AdoptBuyer, {
        deviation: deviation
    }))), (elementVisibilityMap.editDeviation || elementVisibilityMap.deleteDeviation || elementVisibilityMap.meta.hasPrimaryMoreActionsMenu) && /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 2
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, elementVisibilityMap.boostDeviation && /*#__PURE__*/ React.createElement(BoostButton, {
        deviation: deviation,
        className: desktopActionBarStyles['icon']
    }), elementVisibilityMap.sellDeviation && /*#__PURE__*/ React.createElement(SellYourArtLink, {
        className: desktopActionBarStyles['icon'],
        deviation: deviation
    }), elementVisibilityMap.meta.hasPrimaryMoreActionsMenu && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    })), elementVisibilityMap.editBackground && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(EditBackgroundButton, {
        deviation: deviation
    })), elementVisibilityMap.deleteDeviation && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(DeleteButton, {
        deviation: deviation
    })), elementVisibilityMap.editDeviation && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    })))), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 3
    }), /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-right']
    }, elementVisibilityMap.fullscreen && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(ExpandButton, {
        deviation: deviation
    })))));
};
PrimaryDesktopActionBar.displayName = 'PrimaryDesktopActionBar';
export default PrimaryDesktopActionBar;

//# sourceMappingURL=PrimaryDesktopActionBar.js.map